/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_vipUserRelationship = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_vipUserRelationship" | "PdpRespSimilarItemsLanding_vipUserRelationship">;
    readonly " $refType": "PdpRespContainer_vipUserRelationship";
};
export type PdpRespContainer_vipUserRelationship$data = PdpRespContainer_vipUserRelationship;
export type PdpRespContainer_vipUserRelationship$key = {
    readonly " $data"?: PdpRespContainer_vipUserRelationship$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_vipUserRelationship">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespContainer_vipUserRelationship",
  "type": "UserRelationship",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_vipUserRelationship",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsLanding_vipUserRelationship",
      "args": null
    }
  ]
};
(node as any).hash = '4e4b58e485db6b54c44fc14b15350b1b';
export default node;
